import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { useRail } from '../context/RailContext';

const routeTitles = {
    '/experience': 'Experience',
    '/projects':   'Projects',
    '/library':    'Library',
    '/contact':    'Contact',
};

export default function SidebarEntryList() {
    const { items, openIndex, selectItem, deselectAll } = useRail();
    const shouldReduceMotion = useReducedMotion();
    const { pathname } = useLocation();

    const title = routeTitles[pathname];
    const showItems = items && openIndex !== null;

    return (
        <AnimatePresence mode="wait">
            {title && (
                <motion.nav
                    key={pathname}
                    className="sidebar-entries"
                    initial={shouldReduceMotion ? false : { opacity: 0 }}
                    animate={{
                        opacity: 1,
                        transition: shouldReduceMotion ? { duration: 0 } : {
                            duration: 0.3,
                            ease: [0.22, 1, 0.36, 1],
                        },
                    }}
                    exit={shouldReduceMotion ? undefined : {
                        opacity: 0,
                        transition: { duration: 0.2, ease: [0.4, 0, 1, 1] },
                    }}
                >
                    <h3
                        className="sidebar-entries__title"
                        onClick={openIndex !== null ? deselectAll : undefined}
                        style={openIndex !== null ? { cursor: 'pointer' } : undefined}
                    >
                        {title}
                    </h3>
                    <AnimatePresence>
                        {showItems && (
                            <motion.ul
                                key="sidebar-items"
                                initial={shouldReduceMotion ? false : { opacity: 0 }}
                                animate={{
                                    opacity: 1,
                                    transition: shouldReduceMotion ? { duration: 0 } : {
                                        duration: 0.3,
                                        delay: 0.2,
                                        ease: [0.22, 1, 0.36, 1],
                                    },
                                }}
                                exit={shouldReduceMotion ? undefined : {
                                    opacity: 0,
                                    transition: { duration: 0.2, ease: [0.4, 0, 1, 1] },
                                }}
                            >
                                {items.map((item, index) => (
                                    <li
                                        key={item.title}
                                        className={openIndex === index ? 'active' : undefined}
                                        onClick={() => selectItem(index)}
                                    >
                                        {item.title}
                                    </li>
                                ))}
                            </motion.ul>
                        )}
                    </AnimatePresence>
                </motion.nav>
            )}
        </AnimatePresence>
    );
}
